<template>
	<div class="alert" :class="alertCssClass">
		<div v-if="isLogType" class="details" @click="openPatient()">
			<div class="details">
				<div class="icon" :class="isChecked ? 'checked' : ''">
					<shape src="/static/svg/alerts/danger.svg"/>
				</div>
				<div class="info">
					<h1>{{ $t('labels.alerts.alert_value_remove_title') }}</h1>
					<p class="value">{{ $t('labels.alerts.alert_value_remove', { userName }) }}</p>
					<p class="date-time">
						<span class="ago">{{ datetime | timeAgo(vue) }}</span>
						<span>&#8226; {{ datetime | formatDate(vue) }} {{ datetime | formatTime(vue) }}</span>
					</p>
				</div>
				<div class="bullet" v-if="!isChecked">
					<span>&#8226;</span>
				</div>
			</div>
		</div>
		<router-link v-else :to="{ name: routeName, params, query }">
			<div class="details" v-if="alert.args">
				<div class="icon" :class="isChecked ? 'checked' : ''">
					<shape src="/static/svg/alerts/danger.svg"/>
				</div>
				<div class="info">
					<h1>{{ name }}</h1>
					<p v-if="isFalls" class="value">{{ $t('labels.alerts.alert_value_falls', { value, userName }) }}</p>
					<p v-else class="value" v-html="$t('labels.alerts.alert_value', { value, units, userName })"></p>
					<p class="date-time">
						<span class="ago">{{ datetime | timeAgo(vue) }}</span>
						<span>&#8226; {{ datetime | formatDate(vue) }} {{ datetime | formatTime(vue) }}</span>
					</p>
				</div>
				<div class="bullet" v-if="!isChecked">
					<span>&#8226;</span>
				</div>
			</div>
		</router-link>
	</div>
</template>

<script>
import Readings from '@/utils/readings'
export default {
	props: [
		'alert'
	],
	data () {
		return {
			vue: this
		}
	},
	computed: {
		isLogType() {
			console.log(this.alert.args.type, Readings.TYPE_LOGS)
			if (this.alert.args.type === Readings.TYPE_LOGS)
				return true
			return false
		},
		value () {
			switch (this.alert.args.type) {
				case Readings.TYPE_BLOOD_PRESSURE:
					return `${this.alert.args.reading.values.systolic_last} ${this.alert.args.reading.values.diastolic_last}`
				case Readings.TYPE_GEOFENCING:
					return `${this.alert.args.reading.values.latitude} ${this.alert.args.reading.values.longitude}`
				case Readings.TYPE_FALLS:
					return this.$t('readings.falls.fall_detected')
				default:
					return this.alert.args.reading.values.last
			}
		},
		name () {
			return this.alert.args.type ? this.$t(Readings.readingTypes.get(parseInt(this.alert.args.type)).translationKey + '.name') : '(no type)'
		},
		units () {
			return this.alert.args.type ? this.$t(Readings.readingTypes.get(parseInt(this.alert.args.type)).translationKey + '.html') : '(no type)'
		},
		datetime () {
			return this.alert.create_time
		},
		userName () {
			return this.alert.patient.profile.data ? this.alert.patient.profile.data.name : '?'
		},
		routeName () {
			switch (parseInt(this.alert.args.type)) {
				case Readings.TYPE_GEOFENCING:
					return 'WatchGeofencingAlertViewResumeV2'
				default:
					return 'WatchBiometricAlertViewResumeV2'
			}
		},
		params () {
			return {
				user_uid: this.alert.args.user,
				watch_id: this.alert.args.virtual_watch,
				type: Readings.readingTypes.get(parseInt(this.alert.args.type)).route,
				alert_id: this.alert.args.alert_id
			}
		},
		query () {
			return {
				action: 'update'
			}
		},
		alertCssClass () {
			let cssClass
			switch (parseInt(this.alert.args.urgency)) {
				case 1:
					cssClass = 'urgency-min'
					break;
				case 2:
					cssClass = 'urgency-med'
					break;
				case 3:
					cssClass = 'urgency-max'
					break;
				default:
					cssClass = ''
			}
			if (this.isChecked) cssClass += ' checked'
			return cssClass
		},
		isChecked () {
			return !!this.alert.reading_time
		},
		isFalls () {
			return this.alert.args.type === Readings.TYPE_FALLS
		}
	},
	methods: {
		openPatient() {
			// Update reading time
			const user_uid = this.$store.state.user.uid
			const id = this.alert.id
			this.updateAlert(id, user_uid)
			// Watch
			this.$router.push({ name: 'WatchDashboard', params: { user_uid: user_uid, watch_id: this.alert.patient.id } })
		},
		updateAlert (id, user_uid) {
			const model = { id, reading_time: this.$moment().format() }
			return this.$api.warnings.update(this, user_uid, model)
				.then(response => {
					this.$log.info('alerts', 'alert.update OK', response)()
					this.$store.dispatch('getAccountAlerts', { context: this, user_uid: user_uid })
				})
				.catch(error => {
					this.$log.error('alerts', 'alert.update ERROR', error)()
				})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/alerts/Alert.vue